import { useTranslation } from 'next-i18next';
import type { ReactElement } from 'react';
import { useEffect } from 'react';
import type { QueryStatus } from 'react-query';
import styles from './queryStatusHandler.module.css';
import { Icon, IconColor, IconID } from '@common/Icon/Icon';
import { ToastType, useToasts } from '@hooks/useToasts';

type QueryStatusHandlerProps = {
  status: QueryStatus;
  children: ReactElement;
};

export const QueryStatusHandler = ({ status, children }: QueryStatusHandlerProps) => {
  const { t } = useTranslation('toast/toast');
  const { addToast } = useToasts();

  useEffect(() => {
    if (status === 'error') {
      addToast({ content: t('TOAST.ERROR_OCCURRED'), type: ToastType.ERROR });
    }
  }, [status, addToast, t]);

  switch (status) {
    case 'loading':
      return <div data-testid="spinner" className={styles.spinner} />;
    case 'success':
    case 'idle':
      return children;

    // "error", "idle" and the rest
    default:
      return (
        <>
          <Icon id={IconID.WARNING} size={7} color={IconColor.GRAY} />
          &nbsp;{t('TOAST.ERROR_OCCURRED')}
        </>
      );
  }
};
